import { createSlice } from '@reduxjs/toolkit';

import endPoints from '../api/endpoint';
import { getApiCallBasicAuth } from '../api/methods';
import { StaticContentState } from '../types';
import { STATIC_CONTENT_FAQ_CONTACT } from '../Utils/constantData';
import { notify } from '../Utils/toastify';
import store from './store';

const initialState: StaticContentState = {
  data: null,
  loading: false,
};
const staticContentSlice = createSlice({
  name: 'staticContent',
  initialState,
  reducers: {
    setData: (state, action) => {
      const { payload }: any = action;
      state.data = payload;
      return state;
    },
    setDataLoader: (state, action) => {
      const { payload }: any = action;
      state.loading = payload;
    },
  },
});

export const { setData, setDataLoader } = staticContentSlice.actions;

export default staticContentSlice.reducer;

export const getAndSetStaticDataPrivacyAndTerms = (type: any) => {
  store.dispatch(setDataLoader(true));

  getApiCallBasicAuth(
    `${endPoints.staticData.content}?type=${type}`,
    (response: any) => {
      const { data } = response;
      if (data?.data) {
        store.dispatch(setData(data.data));
      }
      store.dispatch(setDataLoader(false));
    },
    (error: any) => {
      console.error(error);
      store.dispatch(setDataLoader(false));
      notify(`Error while fetching ${type} data`, 'error');
    },
    {
      Authorization: `Basic ${btoa(
        `${process.env.API_BASIC_AUTH_CREDENTIALS}`,
      )}`,
    },
  );
};

export const getAndSetStaticData = async (type: STATIC_CONTENT_FAQ_CONTACT) => {
  store.dispatch(setDataLoader(true));
  getApiCallBasicAuth(
    `${endPoints.staticData.contentfaq}${STATIC_CONTENT_FAQ_CONTACT[type]}`,
    (s: any) => {
      const { data: data } = s;
      if (data.data) {
        store.dispatch(setData(data.data));
      }
      store.dispatch(setDataLoader(false));
    },
    (e: any) => {
      console.error(e);
      store.dispatch(setDataLoader(false));
      notify(`Error while fetching ${type} data`, 'error');
    },
    {
      Authorization: `Basic ${btoa(
        `${process.env.API_BASIC_AUTH_CREDENTIALS}`,
      )}`,
    },
  );
};
